import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { StudentService } from 'src/app/_services/student.service';
import { Subscription } from './../../_models/subscription';
import { AuthService } from './../../_services/auth.service';
import { ImageService } from './../../_services/image.service';
import { QuizService } from './../../_services/quiz.service';

import { Component, OnInit } from '@angular/core';
import { Question } from 'src/app/_models/question';

@Component({
  selector: 'app-revise-quiz',
  templateUrl: './revise-quiz.component.html',
  styleUrls: ['./revise-quiz.component.css']
})
export class ReviseQuizComponent implements OnInit {
  quizEnvelop =undefined
  learner:any ={}
  subscription = new Subscription()
  subscriptionId = 0
  server_student_user_id=0

  questionIndex = 0
  questionId = 0
  nextquesitonid = this.questionId + 1
  prevquesitonid = this.questionId - 1
  title=""
  loading=false
  question = undefined
  imageCount = 0

   generating=false
   reloading=false
   questionText=undefined
  constructor(
    public authService: AuthService,
    private route: ActivatedRoute,
    private router:Router,
    private studentService: StudentService,
    private quizService: QuizService,
    private imageService:ImageService
  ) {

  }

  ngOnInit(): void {
    this.studentService.minStudentData.subscribe(
      data =>{
       this.learner=data

    })
    this.route.params.subscribe(
      p => { this.readFromParams(p) }
    )
  }
  readFromParams(params) {
    this.loading=true
    this.questionIndex=+params['indexValue']
    this.server_student_user_id=+params['server_student_user_id']
    let questionId = +params['questionId']
    if (questionId != 0) {
      this.questionId = questionId
      let quizEnvelopId = params['server_quiz_envelop_id']
      if (quizEnvelopId != 0) {
        this.quizService.getQuizEnvelop(quizEnvelopId).subscribe(
          x => {
            this.quizEnvelop = x
            this.title="Quiz for " +this.quizEnvelop.subjectName
            this.question=this.quizEnvelop.questions[this.questionIndex]
            if(this.question.imageListQuestionBody.length>0){
              this.processImages(this.question)
            }else{
              this.loading=false
            }

          }
        )
      }
    }

  }
  async processImages(question:Question){
    let qText = question.questionText
    let myImages= question.imageListQuestionBody

    let iLength = myImages.length

    if(iLength==0){
      this.questionText=question.questionText
      this.loading=false
      this.generating=false
      this.reloading=false
    }

   const imageObservables =myImages.map(pp=>this.imageService.questionObservableImage(this.question.server_question_id,pp['media_file_name']))
   forkJoin(imageObservables).subscribe({
    next:(resultArray)=>{
    for(let i=0;i < resultArray.length;i++){
    let iValue = resultArray[i].rs.data

    let  myImageData = myImages[i]
    let  partName = myImageData['name']
    let  placement = myImageData['placement']
    let imagePlaceHoler = "@@image"+partName
    let imageSource =  "<img src=data:image/png;base64,"+iValue+">"
    if(placement!="IN_LINE_YES"){imageSource= "<div>"+imageSource+"</div>"}
    qText =this.replaceAll(qText,imagePlaceHoler,imageSource)
  }
  this.questionText=qText

  this.loading=false
  this.generating=false
  this.reloading=false
  },error:(err)=>{
    console.error("Error loading images",err)
  }
  }
  )
  }

  // processImages(){
  //   let qText = this.question.questionText
  //   let myImages= this.question.imageListQuestionBody
  //   let iLength = myImages.length
  //   if(iLength>0){ this.loading=true}
  //   let oList = []

  //   for(let i=0;i < myImages.length;i++){
  //      let   myImageData = myImages[i]
  //      let   partName = myImageData['name']
  //      oList.push(this.imageService.questionImage(this.questionId,partName))
  //    }

  //  merge(oList).subscribe(
  //        resultArray=>{
  //         for(let i=0;i < myImages.length;i++){
  //           let iValue = resultArray[i]
  //           let  myImageData = myImages[i]
  //           let  partName = myImageData['name']
  //           let  placement = myImageData['placement']
  //           let imagePlaceHoler = "@@image"+partName
  //           let imageSource =  "<img src=data:image/png;base64,"+iValue+">"
  //           if(placement!="IN_LINE_YES"){imageSource= "<div>"+imageSource+"</div>"}
  //           qText =this.replaceAll(qText,imagePlaceHoler,imageSource)
  //         }
  //         this.question.questionText=qText
  //         this.loading=false
  //         console.log({images:"finished", loading:false})
  //         console.log({question:this.question})
  //        }
  //      )


  // }
  moveNext(){

    this.question=undefined
    console.log({sever_quiz_envelop_id:this.quizEnvelop.server_quiz_envelop_id})
    this.router.navigate(['/student/quiz/revise',this.server_student_user_id,this.quizEnvelop.server_quiz_envelop_id,(this.quizEnvelop.questions[this.questionIndex+1].server_question_id),(this.questionIndex+1)])
  }
  movePrevious(){

    this.question=undefined
    this.router.navigate(['/student/quiz/revise',this.server_student_user_id,this.quizEnvelop.server_quiz_envelop_id,(this.quizEnvelop.questions[this.questionIndex-1].server_question_id),(this.questionIndex-1)])
  }

  replaceAll(str:string, find:string, replace:string) {
    return str.replace(new RegExp(find,'g'), replace);
  }


}

